// src/Contact.js
import React from 'react';
import { Card, CardContent, Typography, Box, IconButton, Link } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const Contact = () => (
    <Card sx={{ mb: 3, boxShadow: 2, borderRadius: 2 }}>
        <CardContent>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
                Contact Me
            </Typography>
            <Box display="flex" alignItems="center" mb={1}>
                <IconButton sx={{ color: 'primary.main', mr: 1 }}>
                    <EmailIcon />
                </IconButton>
                <Link href="mailto:alexa_lukic92@hotmail.com" underline="hover" variant="body1" color="text.primary">
                    alexa_lukic92@hotmail.com
                </Link>
            </Box>
            <Box display="flex" alignItems="center">
                <IconButton sx={{ color: 'primary.main', mr: 1 }}>
                    <PhoneIcon />
                </IconButton>
                <Typography variant="body1" color="text.primary">
                    +381 64 3261459
                </Typography>
            </Box>
            <Typography variant="body2" display="block">Or reach out to me on Linkedin through the link at the top of the page.</Typography>
        </CardContent>
    </Card>
);

export default Contact;
